import type { AppTestCaseGroup } from '../../common/components/ApplicationConfigPage/types'
import { Button, Table, Text } from '../../common/designs'
import { useEnhancedNavigate } from '../../common/hooks'
import ApplicationNameCell from './ApplicationNameCell'
import ApplicationRowStatus from './ApplicationRowStatus'
import { ConfigureDataCollectionSubPathEnum } from './types'

interface Props {
  applicationList: AppTestCaseGroup[]
}

const ApplicationTable = ({ applicationList }: Props) => {
  const { enhancedNavigate: navigate } = useEnhancedNavigate()

  return (
    <div>
      <div className='mb-3 border-b border-gray-200 pb-3'>
        <Text size='m' weight={600} color='darkGray'>
          Tracked applications
        </Text>
        <Text size='xs' color='lightGray' className='mt-1 max-w-2xl leading-relaxed'>
          Status reflects saved rules and the latest config test report. Open an application to edit
          rules and tests.
        </Text>
      </div>
      <div className='-ml-4'>
        <Table
          key='Applications'
          isDense
          size='s'
          head={['Application', 'Status', 'Actions']}
          body={
            applicationList.map((application) => {
              return [
                <ApplicationNameCell key={`${application.appName}-name`} application={application} />,
                <ApplicationRowStatus
                  key={`${application.appName}-status`}
                  application={application}
                />,
                <div className='flex justify-end' key={`${application.appName}-actions`}>
                  <Button
                    variant='ghost'
                    size='xs'
                    className='text-primary-700 hover:bg-primary-50 hover:text-primary-800'
                    onClick={() => {
                      navigate(
                        `${ConfigureDataCollectionSubPathEnum.APPS}/${encodeURIComponent(
                          application.appName,
                        )}`,
                      )
                    }}
                  >
                    Rules & tests
                  </Button>
                </div>,
              ]
            }) ?? []
          }
        />
      </div>
    </div>
  )
}

export default ApplicationTable
